import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import employeeAuthService from "../services/employee-auth.service";
import "./EmployeeLoginPage.css";

export default function EmployeeLoginPage() {
  const navigate = useNavigate();
  const [employeeId, setEmployeeId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Check if employee is already logged in
  useEffect(() => {
    if (employeeAuthService.isLoggedIn() && employeeAuthService.isEmployee()) {
      navigate('/employee/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // Use the employee auth service to login
      await employeeAuthService.login(employeeId, password);
      navigate("/employee/dashboard");
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.error || "Giriş başarısız. Lütfen çalışan ID ve şifrenizi kontrol edin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="employee-login-container">
      <div className="employee-login-card">
        <h2>Çalışan Girişi</h2>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="employeeId">Çalışan ID</label>
            <input
              type="text"
              id="employeeId"
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Şifre</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}